import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';
import { StatusUpdate } from 'api/status-updates';
import {
  loadAllStatusUpdates,
  loadStatusUpdates,
  statusUpdatesLoadingState,
} from '../actions';
import {
  appendStatusUpdate,
  setStatusUpdates,
  setStatusUpdatesLoading,
} from '../slice';

function* loadAllStatusUpdatesManager(action: PayloadAction<StatusUpdate[]>) {
  const { payload } = action;

  try {
    yield put(setStatusUpdates(payload));
  } catch {
    // TODO
  }
}
export const watchLoadAllStatusUpdates = function* () {
  yield takeLatest(loadAllStatusUpdates.type, loadAllStatusUpdatesManager);
};
function* loadStatusUpdatesManager(action: PayloadAction<StatusUpdate>) {
  const { payload } = action;

  try {
    yield put(appendStatusUpdate(payload));
  } catch {
    // TODO
  }
}
export const watchLoadStatusUpdates = function* () {
  yield takeLatest(loadStatusUpdates.type, loadStatusUpdatesManager);
};
function* setStatusUpdatesLoadingStateManager(action: PayloadAction<boolean>) {
  const { payload } = action;

  try {
    yield put(setStatusUpdatesLoading(payload));
  } catch {
    // TODO
  }
}
export const watchStatusUpdatesLoadingState = function* () {
  yield takeLatest(
    statusUpdatesLoadingState.type,
    setStatusUpdatesLoadingStateManager,
  );
};
